import { createSelector } from "reselect";
import { IGlobalStore } from "./GlobalStore";

export const getMakerTokens = (state: IGlobalStore) => state.makerTokens;
export const getTakerTokens = (state: IGlobalStore) => state.takerTokens;

export const allSelectedTokens = createSelector(getMakerTokens, getTakerTokens, (maker, taker) => {
  return [...maker, ...taker];
});
